import { Modal } from '../Modal';
import { PreviewTable } from '../PreviewTable';
import { formatDateTime, toIso } from '../../lib/formatDate';

export interface OtherInfoData {
  createdAt?: string | null;
  createdByName?: string | null;
  updatedAt?: string | null;
  updatedByName?: string | null;
}

/**
 * Read-only audit popover opened from a row's Other Info action — reference §14.
 *
 * This is the ONLY place row-level audit metadata appears in a list. Promoting it to
 * columns would cost width on every screen to answer a question asked once a month.
 */
export function OtherInfoModal({
  open,
  onClose,
  data,
  id,
}: {
  open: boolean;
  onClose: () => void;
  data: OtherInfoData | null;
  id?: string;
}) {
  if (!data) {
    return null;
  }

  return (
    // `sm`: pure information, no fields.
    <Modal open={open} onClose={onClose} title="Other Info" size="sm" id={id ?? 'other-info-modal'}>
      <PreviewTable
        rows={[
          { label: 'Created by', value: data.createdByName?.trim() || undefined },
          { label: 'Created at', value: <Stamp value={data.createdAt} /> },
          { label: 'Updated by', value: data.updatedByName?.trim() || undefined },
          { label: 'Updated at', value: <Stamp value={data.updatedAt} /> },
        ]}
      />
    </Modal>
  );
}

function Stamp({ value }: { value?: string | null }) {
  if (!value) {
    return null;
  }

  return (
    <time dateTime={toIso(value)} className="font-mono tabular-nums">
      {formatDateTime(value)}
    </time>
  );
}
